const MAIN_FRAMES = {
  WAS_VIEW: 'WAS View',
  WAS_DETAIL: 'WAS Detail',
  ACTIVE_TRANSACTION_LIST: 'Active Transaction List',
  WAS_ALERT_DETAIL: 'Alert Detail - WAS',
  TRANSACTION_INFO: 'Transaction Info',

  WEB_SERVER_VIEW: 'Web Server View',
  WEB_SERVER_DETAIL: 'Web Server Detail',
  WEB_SERVER_ALERT_DETAIL: 'Alert Detail - Web Server',

  TRANSACTION_VIEW: 'Transaction View',
  TRANSACTION_DETAIL: 'Transaction Detail',
  TRANSACTION_ALERT_DETAIL: 'Alert Detail - Transaction',

  URL_MONITORING_VIEW: 'URL Monitoring View',
  URL_MONITORING_DETAIL: 'URL Monitoring Detail',
  URL_MONITORING_ALERT_DETAIL: 'Alert Detail - URL Monitoring',

  WEB_APPLICATION_VIEW: 'Web Application View',
  WEB_APPLICATION_DETAIL: 'Web Application Detail',
  WEB_APPLICATION_PAGE_ANALYSIS_DETAIL: 'Web Application Page Analysis Detail',
  WEB_APPLICATION_ALERT_DETAIL: 'Alert Detail - Web Application',
  AJAX_REQUEST_HISTORY_DETAIL: 'Ajax Request History Detail',

  PAGE_PERFORMANCE_MONITORING_VIEW: 'Page Performance Monitoring View',
  PAGE_PERFORMANCE_MONITORING_ALERT_DETAIL: 'Alert Detail - Page Performance Monitoring',

  RUM_USER_MONITORING_VIEW: 'RUM User Monitoring View',
  RUM_USER_MONITORING_DETAIL: 'RUM User Monitoring Detail',
  USER_MONITORING_ALERT_DETAIL: 'Alert Detail - User Monitoring',

  RUM_BROWSER_ERROR_TRACKING_VIEW: 'RUM Browser Error Tracking View',
  RUM_BROWSER_ERROR_TRACKING_DETAIL: 'RUM Browser Error Tracking Detail',
  RUM_BROWSER_ERROR_TRACKING_ALERT_DETAIL: 'Alert Detail - Browser Error Tracking',

  TRACES_VIEW: 'Traces View',

  DAILY_REPORT: 'Daily Report',
  AGENT_WORKLOAD: 'Agent Workload',

  APM_OVERVIEW: 'APM Overview',
  APM_OVERVIEW_ALERT_DETAIL: 'Alert Detail - APM Overview',
} as const;

export const APPLICATION_FRAME_NAMES = {
  WAS_VIEW: {
    FILTERS: `${MAIN_FRAMES.WAS_VIEW}/Filters`,
    WAS_LIST: `${MAIN_FRAMES.WAS_VIEW}/WAS List`,
    ALERT_COUNT: `${MAIN_FRAMES.WAS_VIEW}/Alert Count`,
  },
  APM_OVERVIEW: {
    ALERT_COUNT: `${MAIN_FRAMES.APM_OVERVIEW}/Alert Count`,
    ACTIVE_TRANSACTION_MONITOR: `${MAIN_FRAMES.APM_OVERVIEW}/Active Transaction Monitor`,
    ACTIVE_TRANSACTION: `${MAIN_FRAMES.APM_OVERVIEW}/Active Transaction`,
    DB_CONNECTION_POOL: `${MAIN_FRAMES.APM_OVERVIEW}/DB Connection Pool`,
    TRANSCACTION_MONITOR: `${MAIN_FRAMES.APM_OVERVIEW}/Transaction Monitor`,
    TODAY_METRIC: `${MAIN_FRAMES.APM_OVERVIEW}/Today Metric`,
    APPLICATION_METRIC: `${MAIN_FRAMES.APM_OVERVIEW}/Application Metric`,
    APPLICATION_METRIC_STAT_PREVIEW: `${MAIN_FRAMES.APM_OVERVIEW}/Stat Preview`,
    ALERT: `${MAIN_FRAMES.APM_OVERVIEW}/Alert`,
  },
  APM_OVERVIEW_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.APM_OVERVIEW_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.APM_OVERVIEW_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.APM_OVERVIEW_ALERT_DETAIL}/Clear System Alert`,
  },
  WAS_DETAIL: {
    ACTIVES: `${MAIN_FRAMES.WAS_DETAIL}/Actives`,
    ACTIVES_TREND: `${MAIN_FRAMES.WAS_DETAIL}/Actives Trend`,
    ACTIVES_DETAIL: `${MAIN_FRAMES.WAS_DETAIL}/Actives Detail`,
    ACTIVES_DETAIL_KILL_THREAD: `${MAIN_FRAMES.WAS_DETAIL}/Actives Detail - Kill Thread`,
    CONFIG: `${MAIN_FRAMES.WAS_DETAIL}/Config`,
    DATA_SOURCE: `${MAIN_FRAMES.WAS_DETAIL}/Data Source`,
    HEAP_DUMP: `${MAIN_FRAMES.WAS_DETAIL}/Heap Dump`,
    HEAD_DUMP_EXEC: `${MAIN_FRAMES.WAS_DETAIL}/[Exec] Heap Dump`,
    GARBAGE_COLLECTION: `${MAIN_FRAMES.WAS_DETAIL}/Garbage Collection`,
    GARBAGE_COLLECTION_JVM_GC_STAT: `${MAIN_FRAMES.WAS_DETAIL}/Garbage Collection - JVM/GC Stat`,
    GARBAGE_COLLECTION_GC_ANALYSIS_REPORT: `${MAIN_FRAMES.WAS_DETAIL}/Garbage Collection - GC Analysis Report`,
    METRIC: `${MAIN_FRAMES.WAS_DETAIL}/Metric`,
    INFORMATION: `${MAIN_FRAMES.WAS_DETAIL}/Information`,
    INFORMATION_WAS_GROUP: `${MAIN_FRAMES.WAS_DETAIL}/Information - WAS Group`,
    TRANSACTIONS: `${MAIN_FRAMES.WAS_DETAIL}/Transactions`,
    THREAD_DUMP: `${MAIN_FRAMES.WAS_DETAIL}/Thread Dump`,
    THREAD_DUMP_DETAIL: `${MAIN_FRAMES.WAS_DETAIL}/Thread Dump Detail`,
    LIBRARIES: `${MAIN_FRAMES.WAS_DETAIL}/Libraries`,
    LOADED_CLASS: `${MAIN_FRAMES.WAS_DETAIL}/Loaded Class`,
    LOADED_CLASS_LIST: `${MAIN_FRAMES.WAS_DETAIL}/Loaded Class List`,
    ALERT: `${MAIN_FRAMES.WAS_DETAIL}/Alert`,
  },
  WAS_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.WAS_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.WAS_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.WAS_ALERT_DETAIL}/Clear System Alert`,
  },
  ACTIVE_TRANSACTION_LIST: {
    DETAIL: `${MAIN_FRAMES.ACTIVE_TRANSACTION_LIST}/Detail`,
    DETAIL_LIST: `${MAIN_FRAMES.ACTIVE_TRANSACTION_LIST}/Detail List`,
    DETAIL_CHART: `${MAIN_FRAMES.ACTIVE_TRANSACTION_LIST}/Detail Chart`,
    DETAIL_TREND: `${MAIN_FRAMES.ACTIVE_TRANSACTION_LIST}/Detail Trend`,
  },
  TRANSACTION_INFO: {
    DETAIL: `${MAIN_FRAMES.TRANSACTION_INFO}/Detail`,
    ACTIVE_HISTORY: `${MAIN_FRAMES.TRANSACTION_INFO}/Active History`,
    STACK_TRACE: `${MAIN_FRAMES.TRANSACTION_INFO}/StackTrace`,
  },
  WEB_SERVER_VIEW: {
    FILTERS: `${MAIN_FRAMES.WEB_SERVER_VIEW}/Filters`,
    ALERT_COUNT: `${MAIN_FRAMES.WEB_SERVER_VIEW}/Alert Count`,
    SUMMARY: `${MAIN_FRAMES.WEB_SERVER_VIEW}/Summary`,
    ACTIVE_CONNECTION: `${MAIN_FRAMES.WEB_SERVER_VIEW}/Active Connection`,
    WEB_SERVER_LIST: `${MAIN_FRAMES.WEB_SERVER_VIEW}/Web Server List`,
  },
  WEB_SERVER_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Information`,
    INFORMATION_WEB_SERVER_GROUP: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Information - Web Server Group`,
    METRIC: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Metric`,
    ACTIVE_WEB_TRANSACTIONS: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Active Web Transaction`,
    ACTIVE_WEB_TRANSACTIONS_DETAIL: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Active Web Transaction Detail`,
    WEB_TRANSACTIONS: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Web Transaction`,
    UPSTREAM: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Upstream`,
    WORKER: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Worker`,
    CACHE: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Cache`,
    CONFIG: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Config`,
    ALERT: `${MAIN_FRAMES.WEB_SERVER_DETAIL}/Alert`,
  },
  WEB_SERVER_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.WEB_SERVER_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.WEB_SERVER_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.WEB_SERVER_ALERT_DETAIL}/Clear System Alert`,
  },
  TRANSACTION_VIEW: {
    FILTERS: `${MAIN_FRAMES.TRANSACTION_VIEW}/Filters`,
    CURRENT_STAT_TREND: `${MAIN_FRAMES.TRANSACTION_VIEW}/Current Stat Trend`,
    TOP_5_CARD: `${MAIN_FRAMES.TRANSACTION_VIEW}/Top 5 Card`,
    TRANSACTION_TREND: `${MAIN_FRAMES.TRANSACTION_VIEW}/Transaction Trend`,
    TRANSACTION_COUNT: `${MAIN_FRAMES.TRANSACTION_VIEW}/Transaction Count`,
    ALERT_COUNT: `${MAIN_FRAMES.TRANSACTION_VIEW}/Alert Count`,
  },
  TRANSACTION_DETAIL: {
    ETOE_TARGET: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Target`,
    ETOE_PATH: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Path,List`,
    ETOE_INFORMATION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Information`,
    ETOE_METRIC: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Metric`,
    ETOE_CALL_TREE_DETAIL: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Call Tree - Detail`,
    ETOE_CALL_TREE_SUMMARY: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Call Tree - Summary`,
    ETOE_CALL_TREE_TIMELINE_FLAG: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Call Tree - Timeline Flag`,
    ETOE_CALL_TREE_SQL_INFO: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Call Tree - SQL Info`,
    ETOE_SQL_TEXT: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/SQL Text`,
    ETOE_EXCEPTION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Exception`,
    ETOE_ACTIVE_HISTORY: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Active History`,
    WEB_INFORMATION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Web Server Information`,
    WEB_METRIC: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Web Server Metric`,
    WEB_EXCEPTION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Web Server Exception`,
    WEB_ACTIVE_HISTORY: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/Web Server Active History`,
    ETOE_USER_DATA: `${MAIN_FRAMES.TRANSACTION_DETAIL} - EtoE/User Data`,
    DATABASE_INFORMATION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - Database/Information`,
    DATABASE_SQL_STATISTICS_SUMMARY: `${MAIN_FRAMES.TRANSACTION_DETAIL} - Database/SQL Statistics - Summary`,
    DATABASE_SQL_STATISTICS_TRANSACTION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - Database/SQL Statistics - Transaction`,
    DATABASE_SESSION_PERFORMANCE_LIST: `${MAIN_FRAMES.TRANSACTION_DETAIL} - Database/Session Performance List`,
    SPAN_PATH: `${MAIN_FRAMES.TRANSACTION_DETAIL} - OpenTelemetry/Path`,
    SPAN_LIST: `${MAIN_FRAMES.TRANSACTION_DETAIL} - OpenTelemetry/List`,
    SPAN_INFORMATION: `${MAIN_FRAMES.TRANSACTION_DETAIL} - OpenTelemetry/Information`,
    SPAN_TAGS: `${MAIN_FRAMES.TRANSACTION_DETAIL} - OpenTelemetry/Tags`,
    SPAN_LOGS: `${MAIN_FRAMES.TRANSACTION_DETAIL} - OpenTelemetry/Logs`,
    SPAN_ERROR: `${MAIN_FRAMES.TRANSACTION_DETAIL} - OpenTelemetry/Error`,
  },
  TRANSACTION_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.TRANSACTION_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.TRANSACTION_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.TRANSACTION_ALERT_DETAIL}/Clear System Alert`,
  },

  URL_MONITORING_VIEW: {
    FILTERS: `${MAIN_FRAMES.URL_MONITORING_VIEW}/Filters`,
    LIST: `${MAIN_FRAMES.URL_MONITORING_VIEW}/URL List`,
    ALERT_COUNT: `${MAIN_FRAMES.URL_MONITORING_VIEW}/Alert Count`,
  },
  URL_MONITORING_DETAIL: {
    DETAIL: `${MAIN_FRAMES.URL_MONITORING_DETAIL}/Detail`,
    LIST: `${MAIN_FRAMES.URL_MONITORING_DETAIL}/Response List`,
  },
  URL_MONITORING_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.URL_MONITORING_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.URL_MONITORING_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.URL_MONITORING_ALERT_DETAIL}/Clear System Alert`,
  },

  WEB_APPLICATION_VIEW: {
    FILTERS: `${MAIN_FRAMES.WEB_APPLICATION_VIEW}/Filters`,
    APPLICATION_LIST: `${MAIN_FRAMES.WEB_APPLICATION_VIEW}/Application List`,
    TOP_APPLICATIONS: `${MAIN_FRAMES.WEB_APPLICATION_VIEW}/Top Applications`,
    METRIC: `${MAIN_FRAMES.WEB_APPLICATION_VIEW}/Metric`,
    ALERT_COUNT: `${MAIN_FRAMES.WEB_APPLICATION_VIEW}/Alert Count`,
  },
  WEB_APPLICATION_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/Information`,
    ANALYSIS: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/Analysis`,
    SCATTER: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/Scatter`,
    USER_META_INFO: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/User Meta Info`,
    METRIC: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/Metric`,
    EVENT: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/Event`,
    ALERT: `${MAIN_FRAMES.WEB_APPLICATION_DETAIL}/Alert`,
  },
  WEB_APPLICATION_PAGE_ANALYSIS_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.WEB_APPLICATION_PAGE_ANALYSIS_DETAIL}/Information`,
    LOAD_TIMELINE: `${MAIN_FRAMES.WEB_APPLICATION_PAGE_ANALYSIS_DETAIL}/Load Timeline`,
    RESOURCE_TIMELINE: `${MAIN_FRAMES.WEB_APPLICATION_PAGE_ANALYSIS_DETAIL}/Resource Timeline`,
    AJAX_REQUEST_HISTORY: `${MAIN_FRAMES.WEB_APPLICATION_PAGE_ANALYSIS_DETAIL}/Ajax Request History`,
    METRIC: `${MAIN_FRAMES.WEB_APPLICATION_PAGE_ANALYSIS_DETAIL}/Metric`,
  },
  WEB_APPLICATION_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.WEB_APPLICATION_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.WEB_APPLICATION_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.WEB_APPLICATION_ALERT_DETAIL}/Clear System Alert`,
  },
  AJAX_REQUEST_HISTORY_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.AJAX_REQUEST_HISTORY_DETAIL}/Information`,
    CALL_HISTORY: `${MAIN_FRAMES.AJAX_REQUEST_HISTORY_DETAIL}/Call History`,
  },

  PAGE_PERFORMANCE_MONITORING_VIEW: {
    FILTERS: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Filters`,
    PAGE_LOAD_TIME_SCATTER: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Page Load Time Scatter`,
    PAGE_LOAD_TIME_FILTER_META_INFO: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Page Load Time Filter Meta Info`,
    AJAX_PERFORMANCE_METRIC: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Ajax Performance Metric`,
    PAGE_CALLS_PER_SECOND: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Page Calls Per Second`,
    WEB_VITALS_CHART: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Web Vitals Chart`,
    ALERT_COUNT: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_VIEW}/Alert Count`,
  },
  PAGE_PERFORMANCE_MONITORING_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.PAGE_PERFORMANCE_MONITORING_ALERT_DETAIL}/Clear System Alert`,
  },
  RUM_USER_MONITORING_VIEW: {
    FILTERS: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/Filters`,
    LIST: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/User Session Log List`,
    ACTIVE_SESSIONS: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/Active Sessions`,
    ACTIVE_SESSIONS_REGION_RANK: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/Active Sessions Region Rank`,
    SESSION_DURATION_RATIO: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/Session Duration Ratio`,
    KEYWORD: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/Log Keyword`,
    KEYWORD_SAVE: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/[Save] Log Keyword`,
    KEYWORD_DELETE: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/[Delete] Log Keyword`,
    ALERT_COUNT: `${MAIN_FRAMES.RUM_USER_MONITORING_VIEW}/Alert Count`,
  },
  RUM_USER_MONITORING_DETAIL: {
    USER_SESSION_INFO: `${MAIN_FRAMES.RUM_USER_MONITORING_DETAIL}/User Session Info`,
    USER_SESSION_FLOW: `${MAIN_FRAMES.RUM_USER_MONITORING_DETAIL}/User Session Flow`,
    USER_EVENT: `${MAIN_FRAMES.RUM_USER_MONITORING_DETAIL}/User Event`,
    USER_SESSION_REPLAY: `${MAIN_FRAMES.RUM_USER_MONITORING_DETAIL}/User Session Replay`,
    USER_SESSION_REPLAY_SCENE_TIME: `${MAIN_FRAMES.RUM_USER_MONITORING_DETAIL}/User Session Replay Scene Time`,
  },
  USER_MONITORING_ALERT_DETAIL: {
    USER_SESSION_INFO: `${MAIN_FRAMES.USER_MONITORING_ALERT_DETAIL}/User Session Info`,
    USER_SESSION_FLOW: `${MAIN_FRAMES.USER_MONITORING_ALERT_DETAIL}/User Session Flow`,
    USER_EVENT: `${MAIN_FRAMES.USER_MONITORING_ALERT_DETAIL}/User Event`,
    USER_SESSION_REPLAY: `${MAIN_FRAMES.USER_MONITORING_ALERT_DETAIL}/User Session Replay`,
  },
  RUM_BROWSER_ERROR_TRACKING_VIEW: {
    FILTERS: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/Filters`,
    LIST: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/Browser Error Log List`,
    COUNT_CHART: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/Browser Error Count Chart`,
    OCCURRENCE_CHART: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/Browser Error Occurrence Chart`,
    KEYWORD: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/Log Keyword`,
    KEYWORD_SAVE: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/[Save] Log Keyword`,
    KEYWORD_DELETE: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/[Delete] Log Keyword`,
    ALERT_COUNT: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_VIEW}/Alert Count`,
  },
  RUM_BROWSER_ERROR_TRACKING_DETAIL: {
    ANALYSIS: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_DETAIL}/Browser Error Analysis`,
  },
  BROWSER_ERROR_TRACKING_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.RUM_BROWSER_ERROR_TRACKING_ALERT_DETAIL}/Clear System Alert`,
  },
  TRACES_VIEW: {
    FILTERS: `${MAIN_FRAMES.TRACES_VIEW}/Filters`,
    TRACES_LIST: `${MAIN_FRAMES.TRACES_VIEW}/Traces List`,
  },

  // APP > PA
  DAILY_REPORT: {
    DAILY_REPORT: `${MAIN_FRAMES.DAILY_REPORT}/Daily Report`,
    HOURLY_REPORT: `${MAIN_FRAMES.DAILY_REPORT}/Hourly Report`,
    TXN_SUMMARY: `${MAIN_FRAMES.DAILY_REPORT}/Txn Summary`,
    SQL_SUMMARY: `${MAIN_FRAMES.DAILY_REPORT}/Sql Summary`,
    ERROR_SUMMARY: `${MAIN_FRAMES.DAILY_REPORT}/Error Summary`,
    TXN_DETAIL: `${MAIN_FRAMES.DAILY_REPORT}/Txn Detail`,
    SQL_DETAIL: `${MAIN_FRAMES.DAILY_REPORT}/Sql Detail`,
    ERROR_DETAIL: `${MAIN_FRAMES.DAILY_REPORT}/Error Detail`,
    TARGET_DAILY_STAT: `${MAIN_FRAMES.DAILY_REPORT}/Target Daily Stat`,
    TARGET_HOURLY_STAT: `${MAIN_FRAMES.DAILY_REPORT}/Target Hourly Stat`,
  },

  AGENT_WORKLOAD: {
    AGENT_WORKLOAD_CHART: `${MAIN_FRAMES.AGENT_WORKLOAD}/Pie & Bar Chart`,
  },
} as const;
